<div class="track-page-wrap w-screen h-screen flex items-center justify-center relative">
    <!-- <img src="../../../assets/images/track-bg.png" alt="Background Image" class="w-full h-full"> -->
    <div class="absolute inset-0 track-page-inner"></div>
    <div class="absolute z-1 bg-[#fff] ml-auto rounded-[30px] lg:px-[3em] py-[6em] text-center">
        <h3 class="mb-0 text-[1em] text-black font-normal mt-0 welcome-text">Welcome to</h3>
        <h1 class="mt-2 mb-2 text-7xl text-[#677db9]">
            <span class="text-style font-bold">Med</span>
            <span class="font-thin">Ease</span>
        </h1>
        <h3 class="text-[#6eabc6] mt-0 mb-0 appointment-text">Medical Online Appointments</h3>
        <div class="mx-auto track-component-inner">
            <p class="text-[#2f4965] phone-text text-[1em] font-normal">Please enter your Mobile number/Booking number</p>
            <form>
                <div class="input-wrapper">
                    <mat-form-field appearance="fill" color="primary" class="w-full">
                        <mat-label class="text-gray-500 text-xs">Phone/Booking number</mat-label>
                        <input matInput name="bookingNo" class="custom-input-style" [(ngModel)]="bookingId" required>
                        <mat-error class="mt-2 text-red-600 text-center custom-error-style">Please Enter Mobile / Booking
                            Number.</mat-error>
                    </mat-form-field>
                    <div class="button-wrapper mt-4 mb-2">
                        <button mat-flat-button color="primary" class="gradient-btn" loadingButton [loading]="isLoading" [disabled]="isLoading"
                            (click)="getBookingUserDetails()">
                            <div class="flex items-center">
                                <img class="w-[15px] h-[15px] mr-3" src="/assets/images/track-icon.png" alt="image">
                                <span class="text-white">Track Now</span>
                            </div>
                        </button>
                    </div>
                    <div *ngIf="errorMessage" class="text-sm text-center text-red-500">{{errorMessage}}</div>
                </div>
            </form>

        </div>
    </div>

    <!-- Mat Spinner  -->
    <ngx-spinner bdColor="rgba(0, 0, 0, 1)" size="default" color="#6eabc6" type="ball-spin-fade"
    [fullScreen]="true">
    <p style="color: #fff"> Fetching details... </p>
    </ngx-spinner>


    <!--Footer Menu-->
    <div class="absolute z-1 bottom-10 text-center">
        <div class="w-[150px] h-[40px] mx-auto">
            <img class="w-[100%] h-[100%] object-contain" src="/assets/images/medease-logo.png" alt="image">
        </div>
        <app-message></app-message>
        <app-footer-menu></app-footer-menu>
    </div>
</div>